(function () {
  var SECTION_SELECTOR = '.oddit-section-main-product';
  var section = document.querySelector(SECTION_SELECTOR);
  if (!section) return;

  function initSection(root) {
    var thumbnails = root.querySelectorAll('.oddit-section-main-product__thumbnail');
    var track = root.querySelector('.oddit-section-main-product__slides');
    var thumbTrack = root.querySelector('.oddit-section-main-product__thumbnails');
    var slides = root.querySelectorAll('.oddit-section-main-product__slide');
    if (!track || slides.length === 0 || thumbnails.length === 0) return;

    function centreIn(container, child) {
      if (!container || container.scrollWidth <= container.clientWidth) return;
      container.scrollTo({
        left: child.offsetLeft - (container.clientWidth - child.offsetWidth) / 2,
        behavior: 'smooth'
      });
    }

    function setActive(index) {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('oddit-section-main-product__slide--active', i === index);
      });
      thumbnails.forEach(function (thumb, i) {
        thumb.classList.toggle('oddit-section-main-product__thumbnail--active', i === index);
      });
      centreIn(thumbTrack, thumbnails[index]);
    }

    function centredIndex() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestGap = Infinity;
      slides.forEach(function (slide, i) {
        var gap = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - mid);
        if (gap < bestGap) {
          bestGap = gap;
          best = i;
        }
      });
      return best;
    }

    root.addEventListener('oddit:variant-image', function (e) {
      var index = -1;
      slides.forEach(function (slide, i) {
        if (slide.getAttribute('data-image-id') === String(e.detail.imageId)) index = i;
      });
      if (index < 0) return;
      setActive(index);
      centreIn(track, slides[index]);
    });

    thumbnails.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        setActive(i);
        centreIn(track, slides[i]);
      });
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        setActive(centredIndex());
      }, 80);
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn || !window.OdditCartDrawer) return;

      var variantId = Number(btn.getAttribute('data-variant-id'));
      if (!variantId) return;

      var quantity = Number(btn.getAttribute('data-quantity')) || 1;
      var restWidth = btn.getBoundingClientRect().width;
      btn.style.minWidth = restWidth + 'px';
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');

      window.OdditCartDrawer.addToCart(variantId, quantity)
        .then(function () {
          window.OdditCartDrawer.open();
        })
        .finally(function () {
          // the variant may have changed to a sold-out one mid-request
          btn.disabled = btn.getAttribute('data-available') === 'false';
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          btn.style.minWidth = '';
        });
    });
  }

  function formatMoney(cents) {
    if (window.OdditCartDrawer && window.OdditCartDrawer.formatMoney) {
      return window.OdditCartDrawer.formatMoney(cents);
    }
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function initVariantPicker(root) {
    var picker = root.querySelector('[data-variant-picker]');
    var json = picker && picker.querySelector('[data-variant-json]');
    if (!json) return;

    var variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch (e) {
      return;
    }

    var fieldsets = picker.querySelectorAll('.oddit-section-main-product__option');

    function selectedOptions() {
      var values = [];
      fieldsets.forEach(function (fieldset, i) {
        var checked = fieldset.querySelector('input:checked');
        values[i] = checked ? checked.value : null;
      });
      return values;
    }

    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var match = variants[i].options.every(function (value, j) {
          return value === options[j];
        });
        if (match) return variants[i];
      }
      return null;
    }

    // A value is available when some in-stock variant carries it alongside the
    // values already chosen in the *earlier* options - same rule as Shopify's
    // option_value.available, so the first render and JS agree
    function updateAvailability(options) {
      fieldsets.forEach(function (fieldset, i) {
        fieldset.querySelectorAll('input').forEach(function (input) {
          var available = variants.some(function (variant) {
            if (!variant.available || variant.options[i] !== input.value) return false;
            for (var j = 0; j < i; j++) {
              if (variant.options[j] !== options[j]) return false;
            }
            return true;
          });
          var label = input.closest('.oddit-section-main-product__option-value');
          label.classList.toggle('oddit-section-main-product__option-value--unavailable', !available);
          var srText = label.querySelector('[data-unavailable-label]');
          if (srText) srText.textContent = available ? '' : ', sold out';
        });
        var selected = fieldset.querySelector('[data-option-selected]');
        if (selected) selected.textContent = options[i] || '';
      });
    }

    function updatePrice(variant) {
      var current = root.querySelector('[data-current-price]');
      var compare = root.querySelector('[data-compare-price]');
      if (current) current.textContent = formatMoney(variant.price);
      if (compare) {
        var onSale = variant.compare_at_price > variant.price;
        compare.hidden = !onSale;
        if (onSale) compare.textContent = formatMoney(variant.compare_at_price);
      }
    }

    function updateButton(variant) {
      var btn = root.querySelector('[data-add-to-cart]');
      if (!btn) return;
      var label = btn.querySelector('[data-button-label]');
      var available = !!(variant && variant.available);

      btn.setAttribute('data-available', String(available));
      if (variant) btn.setAttribute('data-variant-id', variant.id);
      if (!btn.classList.contains('is-loading')) btn.disabled = !available;
      if (!label) return;

      if (!variant) {
        label.textContent = 'Unavailable';
      } else if (!available) {
        label.textContent = 'Sold Out';
      } else {
        label.textContent = (btn.getAttribute('data-label') || 'ADD TO CART') + ' - ' + formatMoney(variant.price);
      }
    }

    function onChange() {
      var options = selectedOptions();
      var variant = findVariant(options);

      updateAvailability(options);
      updateButton(variant);
      if (!variant) return;

      updatePrice(variant);
      if (variant.image_id) {
        root.dispatchEvent(new CustomEvent('oddit:variant-image', { detail: { imageId: variant.image_id } }));
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    updateAvailability(selectedOptions());

    picker.addEventListener('change', function (e) {
      if (e.target.matches('.oddit-section-main-product__option-input')) onChange();
    });
  }

  initSection(section);
  initVariantPicker(section);

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector(SECTION_SELECTOR);
    if (!s) return;
    initSection(s);
    initVariantPicker(s);
  });
})();